import { render, staticRenderFns } from "./AlterarDadosServico.vue?vue&type=template&id=78b32ee2&scoped=true"
import script from "./AlterarDadosServico.vue?vue&type=script&lang=js"
export * from "./AlterarDadosServico.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosServico.vue?vue&type=style&index=0&id=78b32ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b32ee2",
  null
  
)

export default component.exports